import { render, staticRenderFns } from "./MyCouriers.vue?vue&type=template&id=0152f97e&scoped=true"
import script from "./MyCouriers.vue?vue&type=script&lang=js"
export * from "./MyCouriers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0152f97e",
  null
  
)

export default component.exports